import axios from 'axios';
import { baseUrl } from '../hooks/useEndpoints';

/**
 * Endpoints Weekly Reports — Programmazione Campo.
 * Spec: LEOPART_ProgrammazioneCampo_Spec_v1.1.1.md (Sez 14, 17 righe 1957-1964).
 */

export interface IWeeklyReportSummary {
  sessionsPlanned: number;
  sessionsExecuted: number;
  totalDuration: number;
  totalEWT: number;
  totalCE: number;
  avgIPS: number;
  avgCLS: number;
  acwrEnd: number;
  monotony: number;
  strain: number;
  narrativeText?: string;
}

export interface IAthleteBreakdown {
  athleteId: string;
  firstName?: string;
  lastName?: string;
  sessionsPlanned?: number;
  sessionsExecuted?: number;
  totalMinutes?: number;
  totalCE?: number;
  totalAU?: number;
  status?: 'ok' | 'low_load' | 'at_risk' | 'injured';
  notes?: string;
}

export interface IGpsComparisonRow {
  coachSessionId: string;
  dayLabel: string;
  plannedIPS?: number;
  gpsIPS?: number;
  deltaPercent?: number;
  accuracy?: string;
}

export interface IAtRiskAthlete {
  athleteId: string;
  severity: 'critical' | 'warning';
  reason: string;
  suggestion?: string;
}

export interface ITrendMetric {
  current: number;
  previous: number;
  delta: number;
}

export interface IWeeklyReport {
  _id: string;
  entityId: string;
  teamId: string;
  weekNumber: number;
  season: string;
  startDate: string;
  endDate: string;
  summary: IWeeklyReportSummary;
  athleteBreakdown: IAthleteBreakdown[];
  matchSummary?: {
    matchSessionId?: string;
    opponent?: string;
    result?: string;
    avgMinutesPlayed?: number;
    avgPerformance?: number;
    topContributors?: Array<{
      athleteId: string;
      minutes: number;
      loadAU: number;
      rating?: number;
    }>;
  };
  gpsComparison?: IGpsComparisonRow[];
  calibrationApplied?: Array<{ tagName: string; adjustment: number }>;
  atRiskAthletes?: IAtRiskAthlete[];
  trendsVsPreviousWeek?: {
    ce?: ITrendMetric;
    ips?: ITrendMetric;
    cls?: ITrendMetric;
    monotony?: ITrendMetric;
    strain?: ITrendMetric;
    narrativeText?: string;
  };
  nextWeekSuggestions?: string[];
  generatedAt: string;
  pdfUrl?: string;
  webUrl?: string;
}

export const weeklyReportsEndpoints = {
  list: (teamId: string, limit = 20) =>
    axios.get<IWeeklyReport[]>(`${baseUrl}/weekly-reports`, {
      params: { teamId, limit },
    }),

  get: (id: string) =>
    axios.get<IWeeklyReport>(`${baseUrl}/weekly-reports/${id}`),

  generate: (teamId: string, weekStart: string) =>
    axios.post<IWeeklyReport>(`${baseUrl}/weekly-reports/generate`, {
      teamId,
      weekStart,
    }),

  exportPdf: (id: string) =>
    axios.get<Blob>(`${baseUrl}/weekly-reports/${id}/export`, {
      params: { format: 'pdf' },
      responseType: 'blob',
    }),
};
